import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        flexDirection: "column",
        background: "#E4F5EC",
        minWidth: "49%",
        height: "150px",
        padding: "18px 22px 18px 22px",
        borderRadius: "8px",
        color: theme.colors.obsidian,
        letterSpacing: 0,
        cursor: "pointer",
    },

    mobile_container: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        flexDirection: "column",
        background: "#E4F5EC",
        borderRadius: "4px",
        color: theme.colors.obsidian,
        letterSpacing: 0,
        width: "100%",
        height: "126px",
        padding: "16px",
    },

    firstRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        marginBottom: "41px",
    },

    mobile_firstRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        marginBottom: "12px",
    },

    firstRow_left_container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "15px",
        minWidth: "50px",
    },

    firstRow_right_container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "15px",
    },

    mobile_firstRow_right_container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "0px 3px",
    },

    secondRow: {
        color: "#7A7A7A",
        fontSize: "14px",
        marginBottom: "7px",
    },
    mobile_secondRow: {
        color: "#7A7A7A",
        fontSize: "14px",
        marginBottom: "16px",
        width: "100%",
    },

    thirdRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        fontSize: "16px",
        color: "#353535",
    },

    boldTitle: {
        fontSize: "20px",
    },

    bottomDrawer_container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        flexDirection: "column",
        padding: "45.5px 20px 31.5px 20px",
        color: "#353535",
        fontSize: "18px",
        letterSpacing: 0,
        gap: "32px",
    },

    bottomDrawer_span: {
        cursor: "pointer",
    },

    renameIcon: {
        height: "22px",
        width: "22px",
    },

    inputClass: {
        fontSize: "18px",
        border: "none",
        borderBottom: "1px solid black",
        background: "#E4F5EC",
        width: "180px",

        "&:focus": {
            outline: "none",
        },
    },
}));

export default useStyles;
